import {Component, OnInit, OnDestroy} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

import {CommonService, LeadService} from "../../../_services";
import {Subscription} from "rxjs";
import {de} from "date-fns/locale";
// import { copyFileSync } from 'fs';

@Component({
  selector: "app-settings",
  templateUrl: "./settings-form.component.html",
})
export class SettingsFormComponent implements OnInit {
  contactSettingsForm: FormGroup;
  systemURL: {
    id: String;
    base_url: String;
    referral_base_url: String;
    referral_base_url_error: String;
    trade_account_base_url: String;
  }[] = [];
  baseURL: String;
  referralBaseUrl: String;
  referralBaseUrlError: String;
  tradeAccountBaseUrl: String;
  submitted: Boolean = false;
  errMsg: String = "";
  successMsg: String = "";
  projectList: any[] = [];
  private subscription: Subscription;
  userId: string = localStorage.getItem("uid") || "";
  constructor(
    private fb: FormBuilder,
    private _common: CommonService,
    private _lead: LeadService
  ) {}

  ngOnInit() {
    this.contactSettingsForm = this.fb.group({
      calendly_url: [null, []],
      send_assigned_client_email: ["", []],
    });
    this.fetchContactSettings(this.userId);
  }

  fetchContactSettings(userId: string) {
    this.submitted = true;
    this._lead.fetchContactSettings(userId).subscribe(
      (res) => {
        console.log(res[0].payload.doc.data(), "data");
        this.contactSettingsForm.patchValue({
          calendly_url: res[0].payload.doc.data()["calendly_url"],
          send_assigned_client_email:
            res[0].payload.doc.data()["send_assigned_client_email"],
        });
      },
      (err) => {}
    );
  }

  onFormSubmit() {
    this.submitted = true;
    if (this.contactSettingsForm.invalid) {
      return;
    }
    let form = this.contactSettingsForm.value;
    form.user_id = this.userId;
    form.contact_id = localStorage.getItem("contactId");
    this._common.showLoader(true);
  }

  capitalizeFirstLetter(string) {
    if (string && string.length > 0) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else {
      return string;
    }
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
